import { login, logout, editInfo, getInfo, loginUser } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'

const state = {
  token: getToken(),
  id: 0,
  avatar: '',
  account: '',
  name: '',
  mobile: '',
  level: 0,
  rank_id: 0,
  platform_id: 0,
  department_id: 0,
  department_group_id: 0,
  department_group_position_id: 0,
  department_group_position_worker_id: 0,
  department_six_id: 0,
  department_seven_id: 0,
  department_eight_id: 0,
  platform_name: '',
  department_name: '',
  department_group_name: '',
  department_group_position_name: '',
  department_group_position_worker_name: '',
  department_six_name: '',
  department_seven_name: '',
  department_eight_name: '',
  leader: 0,
  type: 0,
  daily_report_dim: [1],
  open_id: '',
  user_message: {},
  super_manager: -1,
  platform_map: {},
  plat_map: {},
  banners: [],
  loginInfoDialog: false,
  merge_dimension: false,
  dimension_type: '1' // 1: 按子, 2: 按根, 3: 回流
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_ID: (state, id) => {
    state.id = id
  },
  SET_ACCOUNT: (state, account) => {
    state.account = account
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_MOBILE: (state, mobile) => {
    state.mobile = mobile
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_LEVEL: (state, level) => {
    state.level = level
  },
  SET_RANK_ID: (state, rank_id) => {
    state.rank_id = rank_id
  },
  SET_PLATFORM_ID: (state, platform_id) => {
    state.platform_id = platform_id
  },
  SET_DEPARTMENT_ID: (state, department_id) => {
    state.department_id = department_id
  },
  SET_DEPARTMENT_GROUP_ID: (state, department_group_id) => {
    state.department_group_id = department_group_id
  },
  SET_DEPARTMENT_GROUP_POSITION_ID: (state, department_group_position_id) => {
    state.department_group_position_id = department_group_position_id
  },
  SET_DEPARTMENT_GROUP_POSITION_WORKER_ID: (state, department_group_position_worker_id) => {
    state.department_group_position_worker_id = department_group_position_worker_id
  },
  SET_PLATFORM_NAME: (state, platform_name) => {
    state.platform_name = platform_name
  },
  SET_DEPARTMENT_NAME: (state, department_name) => {
    state.department_name = department_name
  },
  SET_DEPARTMENT_GROUP_NAME: (state, department_group_name) => {
    state.department_group_name = department_group_name
  },
  SET_DEPARTMENT_GROUP_POSITION_NAME: (state, department_group_position_name) => {
    state.department_group_position_name = department_group_position_name
  },
  SET_DEPARTMENT_GROUP_POSITION_WORKER_NAME: (state, department_group_position_worker_name) => {
    state.department_group_position_worker_name = department_group_position_worker_name
  },
  SET_DEPARTMENT_SIX: (state, id, name) => {
    state.department_six_id = id
    state.department_six_name = name
  },
  SET_DEPARTMENT_SEVEN: (state, id, name) => {
    state.department_seven_id = id
    state.department_seven_name = name
  },
  SET_DEPARTMENT_EIGHT: (state, id, name) => {
    state.department_eight_id = id
    state.department_eight_name = name
  },
  SET_LEADER: (state, leader) => {
    state.leader = leader
  },
  SET_TYPE: (state, type) => {
    state.type = type
  },
  SET_DAILY_REPORT_DIM: (state, daily_report_dim) => {
    if (typeof daily_report_dim !== 'object') {
      daily_report_dim = [daily_report_dim]
    }
    state.daily_report_dim = daily_report_dim
  },
  SET_OPENID: (state, open_id) => {
    state.open_id = open_id
  },
  SET_USER_MESSAGE: (state, user_message) => {
    state.user_message = user_message
  },
  SET_SUPER_MANAGER: (state, super_manager) => {
    state.super_manager = super_manager
  },
  SET_PLATFORM_MAP: (state, platform_map) => {
    state.platform_map = platform_map
  },
  SET_PLAT_MAP: (state, plat_map) => {
    state.plat_map = plat_map
  },
  SET_BANNERS: (state, banners) => {
    state.banners = banners
  },
  SET_LOGININFO_SHOW_DIALOG: (state, dialog) => {
    state.loginInfoDialog = dialog
  },
  SET_MERGE_DIMENSION: (state, merge_dimension) => {
    state.merge_dimension = merge_dimension
  },
  SET_DIMENSION_TYPE: (state, dimension_type) => {
    state.dimension_type = dimension_type
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { account, password, phrase } = userInfo
    return new Promise((resolve, reject) => {
      login({ account: account.trim(), password: password, phrase: phrase.trim() }).then(response => {
        if (response.data) {
          const { data } = response
          const { token, refresh_token } = data
          commit('SET_TOKEN', token)
          if (response.code === 0) {
            setToken(token, refresh_token)
          }
        }
        commit('SET_LOGININFO_SHOW_DIALOG', false)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        let { data } = response
        if (!data) {
          reject('Verification failed, please Login again.')
        }

        const {
          user_id,
          account,
          name,
          avatar,
          mobile,
          daily_report_dim,
          open_id,
          super_manager,
          merge_dimension,
          dimension_type
        } = data.user_info
        commit('SET_ID', user_id)
        commit('SET_ACCOUNT', account)
        commit('SET_AVATAR', avatar)
        commit('SET_NAME', name)
        commit('SET_MOBILE', mobile)
        commit('SET_DAILY_REPORT_DIM', daily_report_dim)
        commit('SET_OPENID', open_id)
        commit('SET_MERGE_DIMENSION', merge_dimension)
        commit('SET_USER_MESSAGE', data)
        commit('SET_SUPER_MANAGER', super_manager)
        commit('SET_PLATFORM_MAP', data.platform_map.replace(data.app_version, ''))
        commit('SET_PLAT_MAP', data.plat_map.replace(data.app_version, ''))
        commit('SET_DIMENSION_TYPE', dimension_type)

        data = dispatch('setPermissionModel', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  setPermissionModel({ dispatch }, data) {
    const module = [] // 储存有权限的模块
    // 递归循环
    const setPermission = (data, routerType) => {
      data.forEach(element => {
        element.uri = '/' + routerType + element.uri
        if (element.children && element.children.length > 0) {
          element.children = setPermission(element.children, routerType)
        }
      })
      return data
    }

    for (const key in data) {
      if (['user_info', 'permission_all'].indexOf(key) === -1) {
        if (data[key].permission && data[key].permission.length > 0) {
          module.push(key)
          const permission = []
          permission.push(...setPermission(data[key].permission, key))
          const permission_uri = []
          if (data[key].permission_uri.length > 0) {
            permission_uri.push(...data[key].permission_uri.map(router => {
              return '/' + key + router
            }))
          }
          data[key].permission_uri = permission_uri
          data[key].permission = permission
        }
      }
    }
    data.module = module
    // 用户权限
    if (data.module.length > 0 && data.user_info.super_manager !== 1) {
      // 非超管
      const targetName = window.location.hash.split('/')[1]
      let list = data[targetName]
      if (!data[targetName] || list.permission_uri.length === 0) {
        for (let i = 0; i < data.module.length; i++) {
          const element = data.module[i]
          if (data[element].permission_uri.length > 0) {
            list = data[element]
            break
          }
        }
      }
      dispatch('setModuleUserLevel', list.level_info)
    } else {
      if (data.user_info.super_manager === 1) {
        // 超管
        // 没传给setModuleUserLevel的其他参数则为null
        dispatch('setModuleUserLevel', { level: 0, rank_id: 0 })
      }
    }
    return data
  },

  setModuleUserLevel({ commit }, user_level) {
    const {
      level,
      rank_id,
      platform_id,
      department_id,
      department_group_id,
      department_group_position_id,
      department_group_position_worker_id,
      department_six_id,
      department_seven_id,
      department_eight_id,
      platform_name,
      department_name,
      department_group_name,
      department_group_position_name,
      department_group_position_worker_name,
      department_six_name,
      department_seven_name,
      department_eight_name,
      leader,
      type
    } = user_level

    commit('SET_LEVEL', level)
    commit('SET_RANK_ID', rank_id)
    commit('SET_PLATFORM_ID', platform_id)
    commit('SET_DEPARTMENT_ID', department_id)
    commit('SET_DEPARTMENT_GROUP_ID', department_group_id)
    commit('SET_DEPARTMENT_GROUP_POSITION_ID', department_group_position_id)
    commit('SET_DEPARTMENT_GROUP_POSITION_WORKER_ID', department_group_position_worker_id)
    commit('SET_PLATFORM_NAME', platform_name)
    commit('SET_DEPARTMENT_NAME', department_name)
    commit('SET_DEPARTMENT_GROUP_NAME', department_group_name)
    commit('SET_DEPARTMENT_GROUP_POSITION_NAME', department_group_position_name)
    commit('SET_DEPARTMENT_GROUP_POSITION_WORKER_NAME', department_group_position_worker_name)

    commit('SET_DEPARTMENT_SIX', department_six_id, department_six_name)
    commit('SET_DEPARTMENT_SEVEN', department_seven_id, department_seven_name)
    commit('SET_DEPARTMENT_EIGHT', department_eight_id, department_eight_name)
    commit('SET_LEADER', leader)
    commit('SET_TYPE', type)
  },

  changeOpenid({ commit }, open_id) {
    commit('SET_OPENID', open_id)
  },
  changeMergeDimension({ commit }, merge_dimension) {
    commit('SET_MERGE_DIMENSION', merge_dimension)
  },

  // 获取用户信息
  editInfo({ commit }, userFormData) {
    return new Promise((resolve, reject) => {
      editInfo(userFormData).then((response) => {
        commit('SET_AVATAR', userFormData.avatar)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  editMobile({ commit }, userFormData) {
    return new Promise((resolve, reject) => {
      editInfo(userFormData).then((response) => {
        commit('SET_MOBILE', userFormData.mobile)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ID', 0)
        removeToken()
        resetRouter()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  },

  loginUser({ commit }, uid) {
    return new Promise((resolve, reject) => {
      loginUser(uid).then(response => {
        const { data } = response
        const { token, refresh_token } = data
        commit('SET_ID', 0)
        commit('SET_TOKEN', token)
        setToken(token, refresh_token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  resetBanners({ commit }, banners) {
    commit('SET_BANNERS', banners)
  },
  resetLoginDialog({ commit }, show) {
    commit('SET_LOGININFO_SHOW_DIALOG', show)
  },
  resetDimensionType({ commit }, dimensionType) {
    commit('SET_DIMENSION_TYPE', dimensionType)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

